export default{
  "home": {
    "p2": "ホーム",
    "p3": "キャラ",
    "p4": "ニュース",
    "p5": "大会",
    "p6": "スペシャル",
    "p7": "牌山生成方法の公開",
    "p8": "言語",
    "p9": "ヘルプ",
    "p10": "すべて",
    "p11": "お知らせ",
    "p12": "大会",
    "p13": "その他",
    "p14": "ストーリー",
    "p15": "君、麻雀にどういうイメージを持ってる？\n賭博、徹夜、喫煙、古いゲーム?\n確かに、世間の麻雀に対する偏見は未だに存在している。\nだが時代の変化につれて、人々の麻雀への見方も変わってきた。\n「麻雀は競技的、娯楽的な知的活動だ。」\n近年は、様々な麻雀の競技大会・映像作品などが次々と現れ、「プロ雀士になる！」という夢を持つ人も増えてきた。\n競技麻雀が発展を続ける中、 「麻雀一番街」という商店街は世界中の雀士達にとって聖地となった。\nそこには、麻雀を愛する人たちが集まっている。",
    "p16": "キャラ一覧",
    "p17": "九鬼蓮心",
    "p18": "鬼気迫るバーサーカー",
    "p19": "CV 新井里美",
    "p20": "学生時代はよくゲームセンターに潜入して、麻雀を打っていた。何でも賭けたい傾向があり、ラーメンを食べる時も消費時間の奇数か偶数を賭けていた。卒業後、世界周遊したいという理由だけで国境なき医師団に入る。その後とある医者に従って一番市の病院に就職した。昼間は存在感無しだが、仕事を終えてからディスコダンスやギャンブルにひたすら溺れた。しかし段々とギャンブルに対して興味をなくし、色んな雀士にチャレンジしたくなり麻雀一番街に来た。",
    "p21": "プライバシーポリシー",
    "p22": "利用規約",
    "p23": "免責事項",
    "p24": "不正行為について",
    "p25": "メニュー",
    "p26": "コミュニティ",
    "p27": "ギフト受取",
    "p28": "セット購入",
    "p31": "購入",
    "p32": "セール"
  },
  "about": {
    "p2": "ヘルプ",
    "p3": "お問い合わせ、ご意見、ご要望は下記までご連絡ください。",
    "p4": "Twitter: @mahjongpet",
    "p5": "メール：riichicitysupport@mahjong-jp.com",
    "p6": "電話番号：05088839659",
    "p7": "営業時間：9:00～18:00"
  },
  "disclaimer": {
    "p2": "免責事項",
    "p3": "本ゲームのゲームアイテムは、不換紙幣やその他の現実世界の価値に変換または譲渡することはできません。本プラットフォームでのプレイは娯楽目的のみであり、現金やその他の現実世界の価値をいかなる形でも獲得したり引き出したりすることはできません。\n\n「麻雀一番街」は詐欺行為には厳正に対処します。詐欺的な支払い方法でゲームアイテムを購入しようとすると、現地のマネーロンダリング防止法や規制に違反する可能性があります。「麻雀一番街」は、IPアドレス、名前、チャットログを含む（これらに限りません）、お客様から収集した情報を引き渡すとともに、関連する地域の当局に報告する法的義務を負う場合があります。\n\nゲームをプレイすることは娯楽の一つですが、中毒性もあります。私たちはお客様のユーザーエクスペリエンスができるだけ良いものであるように願っていますので、責任を持ってプレイしてください。"
  },
  "legal3": {
    "p2": "不正行為について",
    "p3": "「麻雀一番街」は「コンビ打ち」や他の不正行為に厳しく対処いたします。\n\n明らかに不正な同卓率が検出された場合、又は不正行為が確認された場合、成績の削除、アカウントの利用禁止や削除をさせて頂く場合もございますので、予めご了承ください。\n\n不審なプレイを発見された方は、{href} へお知らせください。下記の情報をご提供いただければ、弊社所定の手続に基づき速やかに対応させていただきます。\n\n・不正を行ったユーザーの名前\n\n・問題局の牌譜URL\n\n今後とも「麻雀一番街」をよろしくお願いいたします。"
  },
  "character": {
    "p2": "女流雀士",
    "p3": "一色清美",
    "p4": "キラキラ一色使い",
    "p5": "CV 小倉唯",
    "p6": "幼い頃は両親と海外に住んでいた。家族麻雀でルールを覚え、自分も麻雀を始めた。卓上では常人を遥かに越える運を発揮する。今までと違う楽しさを見つけるため、麻雀強者が沢山集まる麻雀一番街へ一人で辿り着いた。夢はプロ雀士になることと、世界大会へ参戦すること。",
    "p7": "三宅環奈",
    "p8": "絶対雀感ドリーマー",
    "p9": "CV 新井里美",
    "p10": "天才小説家。子供の頃、両親と離れて一人に。大好きな近所のお姉ちゃんから子供用の麻雀セットを貰い、麻雀を好きになった。一人で四人分の役を演じながら麻雀を打ち、そのストーリーを小説としてネットに発表すると一気に名を立てた。BBSで麻雀一番街の存在を知り、麻雀界を理解するために来た。現在は雀士たちそれぞれの奇妙な過去を聞き出し、小説家としての独特な感性で大げさに自分の作品に書いている。",
    "p11": "東方凪",
    "p12": "会心一撃の淑女",
    "p13": "CV 小倉唯",
    "p14": "家族は地元最大の雀荘を経営している。かつては両親が経営のため忙しくなり、麻雀を嫌う時期もあった。しかしある日偶然にネットで、プロ雀士である父親が出た試合を見て、その輝く姿に魅せられる。やがて父親のようなプロ雀士になるという夢が生まれた。本気で麻雀を打ち始めた彼女は空前絶後の才能を見せつけ、地元の有名雀士になった。しかし最近は謎のスランプに陥り、勝てない日々が続く。現在は不調を抜け出すため、麻雀一番街の雀荘で自分のバランスを調整している。",
    "p15": "五十嵐紗子",
    "p16": "深読みマンハッタン",
    "p17": "CV 長谷川玲奈",
    "p18": "子供の頃は両親が話してくれず、孤独な生活をしていた。ずっとテレビを見て過ごすうちに、人の動きや表情からその真意を読む能力を得る。心を読むことが得意な彼女は、テレビで見た麻雀牌の絵柄や音に惹かれ、人生を麻雀に捧げることを決めた。酒が大好物で、一番街で「秘密を交換する」バーを経営している。すべての雀士の秘密を知っているため、彼女は一番街を牛耳る「謎の存在」即ちボスだという噂も出た。今の段階では、真実はまだ明かされていない。",
    "p19": "九鬼蓮心",
    "p20": "鬼気迫るバーサーカー",
    "p21": "CV 新井里美",
    "p22": "学生時代はよくゲームセンターに潜入して、麻雀を打っていた。何でも賭けたい傾向があり、ラーメンを食べる時も消費時間の奇数か偶数を賭けていた。卒業後、世界周遊したいという理由だけで国境なき医師団に入る。その後とある医者に従って一番市の病院に就職した。昼間は存在感無しだが、仕事を終えてからディスコダンスやギャンブルにひたすら溺れた。しかし段々とギャンブルに対して興味をなくし、色んな雀士にチャレンジしたくなり麻雀一番街に来た。",
    "p23": "天海汐月",
    "p24": "デジタル求道者",
    "p25": "CV 長谷川玲奈",
    "p26": "子供の頃、数学教師の祖父から「麻雀は思考力を高める」と聞いて麻雀を始めた。最初はデータ通り、しっかりした手順で打ったがすぐ停滞期に。先輩と一緒に牌譜を分析して、自分のミスが人の判断を左右する状況もあったと気づき、読みの裏をかく打ち方を鍛えた。やがてもっと強くなるため、雀荘にアルバイトするようになった。データ麻雀の難しさを感じた彼女は、強者と出会い、デジタル派の限界を突破することを目指して一番街に来た。七対子が好きな理由は、山読み、人読み、筋待ちなどの戦術を活かせるから。",
    "p27": "男子雀士",
    "p28": "天宮健一",
    "p29": "傾奇王子",
    "p30": "CV 森嶋秀太",
    "p31": "喋り方がチャラい。毎回必ず言うセリフは「聴牌即リー、単騎王道、ノミは必殺技」。学生時代は同級生の影響で麻雀のルールを知り、そのあとはネット麻雀にハマり「麻雀一番街」というネットゲームのトッププレイヤーになった。一番街に隠れた「謎の存在」の正体が気になって、アルバイトの名義で一番街に来た。彼は少しずつ糸を掴み、バーオーナーの五十嵐紗子を疑い始めた。真相を探し出そうとするうちに彼女から影響を受け、プロ雀士を目指すようになった。",
    "p32": "雀丸",
    "p33": "四川の副露マスター",
    "p34": "CV 森嶋秀太",
    "p35": "四川の副露マスター。中国四川出身のパンダで、四川麻雀をはじめ、各種中国麻雀ルールに詳しい。日本の雀士たちと交流するため麻雀一番街へ。四川麻雀の影響で超攻撃型になった彼だったが、日本式の麻雀から守りの奥義を勉強したいと思っている。日本式の麻雀にハマってはいるが、日本語はそこまでうまくない。",
    "p36": "五月女百合香",
    "p37": "エンジェルメロディ",
    "p38": "CV 石川由依",
    "p39": "5歳年上の兄と二人きりで暮らしている。目は見えないが、あらゆる装飾に関心があり、周りの人に彩りを聞くのが大好き。\n幼い頃に目の病気を患い、ほとんどの時間を病院で過ごした。両親は彼女の治療のためにあらゆる手段を試したが、成果は得られず疲れ果ててしまい、ついには彼女が７歳の時に治療をあきらめ、百合香を見捨ててしまった。\n兄に心配を掛けたくないためにいつも笑顔でいるが、心の中では目が見えないことや友達がいないことに苦しんでおり、一人でいるときに泣いている。\n触覚を鍛えるために兄の直哉から麻雀の模様を教わり、触って分かるように訓練した。百合香が最初に触った麻雀牌は一索で、心の中で模様を見たような奇妙な感覚を覚え、麻雀が好きになった。\n目は見えないものの聴覚は優れており、卓越した音楽の才能の持ち主。彼女の奏でる音楽には聴いている人を勇気づける力がある。その力を病気で苦しむ人を救うために使いたいと思い、病院でアルバイトをしている。その手伝いをしている中で九鬼やあなたと出会うことになる。",
    "p40": "赤羽アテナ",
    "p41": "絶対正義ワルキューレ",
    "p42": "CV 石川由依",
    "p43": "警察官として一番街の安全を守る。いつも上司から「警察官らしい格好をしろ」と注意されているが、一向に改める気はない。身体能力が高く、一番街のチンピラに恐れられている。\n父親はFBIの捜査官で、彼女を連れて外勤することもあった。そのおかげで、彼女は世界中の人々の苦しみや罪を知った。一見自由奔放、強気で乱暴な感じもするが、心優しい一面もある。彼女の願いは、間違って犯罪の道へ走ってしまった少年少女全てを救うこと。\n昔は任務で一度負傷して、九鬼蓮心に看護されたことがある。九鬼蓮心が違法な治療をしているのではないかと疑っており、よく彼女とぶつかる。しかし実際は九鬼のことが気になって、ワイルドな性格のせいで危険に巻き込まれる可能性を心配している。九鬼がディスコダンスする時もついてきたことがある。その後、九鬼を追って雀荘に行って、麻雀が好きになった。",
    "p44": "夏海真凜",
    "p45": "百獣の女王",
    "p46": "CV 直田姫奈 ",
    "p47": "一番街で一番有名な美容師で、いろんな形を作るのがうまい。清純で可憐な見た目で多くの人を魅了する。性格は見た目に反して腹黒い一面がある。また、美容が好きでヘアメイクを得意としているが、実際はお客の頭を自由に調整することができるというコントロール感を好む。\n創意的な事が好きで、麻雀をする時も想像力豊かな手組で、不思議な一打をすることがある。また、麻雀の駆け引きは鋭く、打牌が早いので、「卓上の虎」を自称している。点数をコントロールするのがうまい。\n他の雀士が髪型を整えに来ていたことで知り合った。多くの人をコントロールできるが、五月女直哉をコントロールできないことから好きになった。本当に好きな人がいると恋愛しか考えられなくなる。",
    "p48": "五月女直哉",
    "p49": "バーニングフィスト",
    "p50": "CV 浪川大輔",
    "p51": "五月女百合香の兄。百合香が生まれつき全く目が見えないが、直哉はきっと治ると信じている。\n二人は幼い時に両親に捨てられてしまい、生計を立てるため様々な仕事をしてきた。妹の病気を治すため、より多くのお金を稼ごうとボクシングを始めた。\n元々は優しく内向的な性格だったが、数々の苦労をしてきた経験から、妹以外に対しては冷たく距離をとっている。妹の前では常に優しく、笑顔を見せる。また「妹を守らなければ」というプレッシャーが彼の原動力となっているが、心の奥底には弱い一面も持っている。\n目の見えない妹の触覚を発達させるため、麻雀牌を触る練習を一緒にしていた。\nボクシングの時は拳を振り続け、ひたすら攻めるが、麻雀を打つときは冷静な一面も見せる。",
    "p52": "深瀬アリス",
    "p53": "タクティクス・ゴッデス",
    "p54": "CV 沼倉愛美",
    "p55": "大型財団・深瀬のお嬢様。学生ながら社交の場に顔を出しており、財団のビジネスにも深く関わっている。自信家な頭脳派。家族の力を借りることが好きではなく、自分の手で問題を解決したいという信念がある。 \nメニヤ（手下のスパイ）は天和市の一番街で仕事している。メニヤの報告により麻雀一番街に興味を持ち、訪れることになった。麻雀を始めてから一週間でプロ資格を取り、競技麻雀のチーム「三途インダストリー」に入った。あまりのハマりっぷりに世間からは「深瀬家の麻雀漬けのお嬢様」との呼び声が上がっている。 \n戦術を駆使することが好きで、自分の打ち方を「アリスの絶妙戦術」と呼ぶ。一番街で「月間平均着順2.1」を目標にしているが、今は目標まで遠いらしい。 \nなんでも器用にこなす彼女が唯一苦手なのは料理作り。なぜかレシピ通りに作っても暗黒色の料理が生まれるが、それでも試し続ける。「深瀬アリスは欠点なんてありません、なんでも完璧ですわ！」",
    "p56": "メニヤ",
    "p57": "沈黙の執行者",
    "p58": "CV 悠木碧",
    "p59": "一番ビルズの洋服屋で店員をしているが、その正体は深瀬財団が一番街に派遣したスパイ。住人との会話から一番街の秘密を探り、深瀬アリスがビジネスで有利な立場に立てるよう動いている。\nスパイとしては有能だが店員としての仕事は苦手で、ドアの前で「いらっしゃいませ」と言うしかやることがない。スタイルは抜群で憧れの的になっているが、ぼーっとしていて口下手な面もある。 \n最近はもっと多くの情報を集めるために一番街の雀荘に行き、普段接することのない人たちを観察している。\n嫌なことがあっても我慢するため勘違いされやすいが、噂では以前絡まれた不良10人を店外へ投げたことがある。彼女は噂と主張しているが、真実は当事者しか知らない模様。\n貧しく路頭に迷っているとき深瀬アリスに拾われ、以降彼女の付き人になっている。二人が出会った時、アリスはメニヤの目の中に深い闇を見たが、それでも彼女に手を差し伸べた。メニヤは過去の経験からアリスを警戒したが、その目から警戒心が消えた瞬間、二人の間には沈黙の契約が交わされた。",
    "p60": "AU.RO.RA",
    "p61": "永生の吸血姫",
    "p62": "CV 大西沙織",
    "p63": "（読み：オーロラ）16歳のように見えるが、実は自分が覚えているよりずっと長い年月を生きてきたので、年上らしいところもある。「ヴァンパイア」の希少種である「デイウォーカー」として日中に姿を現すことができるが、純血種のデイウォーカーではないため、日中の移動には特殊な呼吸器が必要。他人に危害を加えないための呼吸器と、自制心を失わないように手を拘束する紐をつけている。 また、自分を見失わないよう、毎日ストラップで縛られている。 \n純血種のデイウォーカーではないため、毎日昼間に自分が誰であるかを忘れ、夜になると回復するという、珍しい記憶喪失の症状に陥っている。麻雀をすると物忘れが治るという噂を信じ、長年麻雀を打ち込み、それが唯一の趣味になっていた。 最近は毎晩東方家の雀荘に通って麻雀を打っている。 また、血を吸わないでも済むのではないかと、いつも赤あり麻雀をして気を紛らわしている。 様々な努力をして、いずれは太陽の光の中を自由に歩き回り、血を吸わない吸血鬼になりたいと願っている。",
    "p64": "不二一気",
    "p65": "未熟な占い師",
    "p66": "CV 杉山紀彰",
    "p67": "自称は三宅環奈が書いた小説の中のキャラ。三宅の小説の設定に不満があり、現実世界に登場して文句を言えるようになった。三宅の小説「一気通貫の勇ましい少年」の主人公「ウサギ次郎」と性格がそっくりなので、一部の子供たちは彼がほんとに小説から出た人物と信じている。\n実際は三宅環奈のいとこで、小説主人公のモデルになった。不二一気は小説家「三宅ウサギ」の大ファンですが、最初は彼女の正体を知らない。彼はある日偶然に三宅の家で小説の手書き原稿を発見して、三宅環奈が三宅ウサギということを知って、三宅の後を追い天和市に来た。\nウサギ次郎は三宅の小説の中では毎日ダラダラ過ごして人を騙す「自称占い師」。よりうまく「ウサギ次郎」を演じるため、不二一気はよく一番街で色んな人に「あなたの運命を教えてあげる」って言いながら、誰でも当てはまることをそれらしく言っている。麻雀する前も自分の運勢を占って、「これから5半荘の順位は1-1-2-2-1だよ」などと言う。彼の予言は半分はずれだが、不思議に他の半分はビッタリ当たれる。",
    "p68": "白羽飛鳥",
    "p69": "金の瞳の魔女",
    "p70": "CV 内田真礼",
    "p71": "謎の中二病少女。いつもNo.001のマークのブレスレットを着ている。異色の右の瞳は「あらゆるものを見通す能力」があると自称している。チーム「Dawn運命騎士」のエースプレイヤーである。\n全く注目されていなかった新参者であったが「天下一番賞」のオーラスでラス目から四暗刻単騎字一色大四喜をアガり、試合を見守る世界中を熱狂の渦に巻き込んでしまった。\nその後も卓越した力を発揮し、天下一番賞で最も注目される番狂わせ者に。「Dawn運命騎士」もチーム「帝皇」と同じく優勝候補とされた。\nしかし決勝戦の日、漫画喫茶で雑誌を読みながら寝てしまい、目が覚めたのは大会終了の2時間後だった。 白羽の天下一番賞の旅はこのような形で終わった。\nその後記者から取材を受けた彼女は、胸を覆い、顔をしかめて、「これが運命の騎士として背負うものだ。しかし、私は決して屈しない。いつかあの傲慢な神の前に立ち、人間でも世界一強くなれることを教えてやる！」と苦しげに語った。",
    "p72": "原道雪",
    "p73": "無双の剣士",
    "p74": "CV ゆかな",
    "p75": "孤児だったところを道場の師匠に拾われ、物心ついた頃から父親代わりの師匠に剣術を習っていた。\n師匠が頼りなく、幼い頃から自立していた道雪。自称「剣雀双絶」の師匠は毎日道場で生徒の練習を指導しながら、道雪を連れて麻雀もやっていた。道場の日常管理は早くから道雪に任されていました。\n剣術が上手いだけでなく、容姿端麗で礼儀正しい彼女は、そのうちに街中で有名人となった。ただ師匠と同じで、剣道と麻雀以外の趣味は皆無。\n昼間は剣道の稽古をし、夜は麻雀をする日々が続いたが、18歳になった日「卒業だ！これからこの道場はお前に任せたぞ。雪ちゃん、頑張って！」というメモを残し、師匠は姿を消した。\n何がなんだかわからないまま日々を過ごした道雪。しかしある日、テレビの中で見覚えのある師匠の顔を発見する。画面には大きな麻雀の試合が中継されていた。それが道雪と「天下一番賞」との出会いだった…",
    "p76": "音無郁子",
    "p77": "メンヘラバーチャル配信者",
    "p78": "CV ゆかな",
    "p79": "ネット麻雀に特化した実力派バーチャルライバー。 私立貴族中学秀桜学園の在校生。彼女は親の悲願を受け入れ、努力の末秀桜学園に入学できたが、思った通りの華やかな人生にはならないことに気付く。彼女はどこへ行っても背景の靜かな木のように、存在感が薄くなるのだ。\n常に暗いオーラを放つ彼女は、インターネット上に自分の居場所を見つけた。薄い画面の中で、郁子はバーチャルライバー「音速奈々子」に変身する。その世界でのみ、彼女は明るい、情熱あふれる陽キャラとなることができるのだ。彼女は話題性が高い「オンライン麻雀」を活動フィールドとし、短期間でランキング上位に駆け上がった。 数々のプロ雀士にも打ち勝ったことから、謎のネット麻雀マスターとしての伝説が始まった。 \nバーチャルな世界で成績を出すだけでは飽き足らず、郁子は現実の世界のプロ麻雀に注目し始めた。 そこで有名になれば、もっと人気が出るのかな…？ そんな思いを抱き、郁子は悩みながらもプロの雀士への道を歩み始める。",
    "p80": "榎宮澪",
    "p81": "白黒世界の孤児",
    "p82": "CV 悠木碧",
    "p83": "幺九街から来た野生犬。幼い時に両親に幺九街というスラムに捨てられた。もともときれいな黒髪だったが、幺九街の子供たちに「こんな美しい髪は野生犬のお前にふさわしくない」と言われ、白いペンキを頭からかけられた。 この事件で視力が低下し、家で鏡に映る自分を見て、この屈辱を忘れないために、髪を白黒の模様にした。\n裏雀荘で遊んでるおじさんが澪を見つけ、彼女に麻雀の才能や強い観察力と計算能力があることに気づき彼女を育てた。彼女の才能で金儲けしようと考え、様々な麻雀の技を教えた。時が経ち、雀荘で収入を得ていた彼女は、おじさんが自分を金儲けの道具として考えていることを知りつつも、居場所を与えてくれたおじさんに感謝しながら生活をしていた。 ある日、おじさんはギャンブルで負けた際に澪を担保に取ろうとした。それに気づき幻滅した彼女はスラム街から逃げ出す。\nその時、自分には麻雀しかないことに気づき、麻雀一番街へと向かい東方雀荘のメンバーになった。彼女の才能は段々注目され、東方雀荘に協力されてプロ雀士になった。彼女の人生はこれから新しいページをめくった。",
    "p84": "小倉奏",
    "p85": "流行を追い求める人",
    "p86": "CV 直田姫奈",
    "p87": "（読み：コクラカナデ）流行を追い求める人。秀桜学園の品行方正な生徒たちからすると、小倉奏は異次元の生物である。彼らは彼女がここにいる意義を理解できず、その世界に入ることもできず、彼女についての噂からかすかな手掛かりを得ることしかできないので、彼女に対して「不良少女」という歪んだイメージを持つようになった。\n小倉奏に関する噂には、本人すら驚くようなものが多い。しかし、彼女はいつもファッションの流行にばかり注目しているので、自分の噂について根掘り葉掘り聞くようなことはほとんどない。流行というのは、あっという間に過ぎ去ってしまうものだ。小倉奏にとって、そのような儚い輝きを追い求めることほど重要かつ緊急性のあることはない。——たとえそのために、堅苦しい校則を破らなければいけないとしても。彗星が地球の引力を気にしないように、彼女はそんなことを気にしないのだ。\nチーム星辰は、このような光り輝く女子高生にすぐに目をつけ、オファーを出し、彼女は喜んでそれを受け入れた。自分が麻雀をしている姿や、あがった様子をSNSに上げ、いいねとコメント数が勢い良く増えていくのを見るのは、彼女の楽しみの一つだ。しかし同時に、彼女は一つの悩みを抱えている。それは、良いあがり方をする頻度があまり高くなく、撮った写真に「輝き」が足りないということだ。どうすれば雀力を高められるか、それが今の彼女にとっての最優先課題になっている。",
    "p88": "不破真昼",
    "p89": "勝利を追う王女",
    "p90": "CV 夏吉ゆうこ",
    "p91": "勝利を追う勇敢な王女、凛とした高嶺の花。\n中央雀院の先代院長の孫娘である不破真昼は、十五歳で初めてプロ雀士として競技場に登場して以来、麻雀界全体の注目を集めている。彼女のキャリアデビューは間違いなく素晴らしく、初めての試合で驚くべき落ち着きと臨機応変な対応を見せ、破竹の勢いで個人戦で1位を獲得した。同年、チーム帝皇に加わった不破真昼は天下一番賞に出場し、決勝戦で伝説の雀士涼城九郎に苦戦の末勝利し、チームが三途インダストリーを打倒、優勝するのに貢献した。この後、不破真昼の名は広く知られ、そして涼城九郎と式部神人の相次ぐ引退は、新たな王の戴冠の壮大な幕開けを告げるものとなった。翌年、不破真昼はチーム帝皇とともに再び天下一番賞に出陣した。新進気鋭のダウンナイツ・オブ・デスティニーを倒して優勝の栄冠を守った今、前人未到の三連覇はこの天才少女の目の前だ。\n多くの記者は不破真昼にはビジネスチャンスがあると気づいたが、麻雀以外での彼女の生活はほぼ白紙だ。記者たちがどんなに調べても、彼女の趣味やスキャンダル、論争を引き起こせるような発言は一切見つからなかった。彼女の目には麻雀しか映っていないようだ。",
    "p92": "犬飼陽菜",
    "p93": "秩序の代理人",
    "p94": "CV 夏吉ゆうこ",
    "p95": "秩序の代理人、微笑みの優しい悪魔。\n今では雀ヶ丘学園の理事長として知られている犬飼陽菜だが、学園を卒業する前に中央雀院からの内部評価でS級予備採用生の1人に認定されたことはあまり知られていない。卒業式が終わった後、彼女のメールボックスに中央雀院からのお祝いと招待状が届いた。テスト不要、学費全額免除、簡単な条件を満たせば多額の奨学金を獲得できる、これが中央雀院が自信満々に彼女に出した条件だった。\n中央雀院が提供するこれほどの優遇を拒む麻雀愛好者はほぼいない。これが麻雀の天才である犬飼陽菜がかつて体験した人もうらやむ人生だったが、彼女は最終的に平凡で、より困難かもしれない道を選んだ。それは、日々衰退していく雀ヶ丘学園の再興を目指すことだった。そのために、彼女は天和大学に入学の申請を出すことを選び、マネジメントと教育学の2つを専攻して、卒業後は母校に戻って就職することにした。\n今、犬飼陽菜は雀ヶ丘チームに入り、麻雀の人生を再開した。デビュー以来、彼女は様々な試合で素晴らしい技を見せ、天和の雀士たちの天才少女に対する記憶を再び呼び起こした。",
    "p96": "立花薫",
    "p97": "癒し系アイドル",
    "p98": "CV 上村祐翔",
    "p99": "優しくて明るい後進型アイドル。星の少年三期団体が初ライカオルブに出演した時、立花薫はたまたまファンである友人と一緒にステージを遠くから見ていただけだった。その偶然かつ驚きの出会いが、その後の立花薫の人生を変えた。\n立花薫はクラシック音楽の名家出身で、両親は有名人であり、兄はヴァイオリン界の新星として注目されていた。同じく非凡な音楽の才能に恵まれた立花薫は考えた末に、家族とは違う道——アイドルになると決意する。\nそれまで基礎のなかった立花薫は短期間で素晴らしいダンスの技術を身につけ、ほぼ完璧な歌声はどのような歌も彼の口から天籟の音として聞こえるようになった。折しも、三期団体の一人だった千葉春暉が退団し、四期予備役志願中の立花薫がプロデューサーにより後任として選抜された。これによって、立花薫はアイドルの道で輝き始めた。\n最年少メンバーでありながら、優しくて頼もしい性格で知られた立花薫は、その春風を浴びるような品格を麻雀卓でも発揮している——上がる時、相手を傷つけないようにわざと翻数を下げることもあった。彼にとって、人と人とのつながりは、勝ち負けよりもはるかに重要だったから。",
    "p100": "鈺燭",
    "p101": "宝玉の龍姫",
    "p102": "CV 田村ゆかり",
    "p103": "神秘の玉から現れた不思議な女の子。奇妙な角と尻尾を持ち、すべてに茫然としていて無知だが、キャプテンに対してだけは自分の家族だと断言している。 \nキャプテンと彼女が一緒に付けた「鈺燭」という名前は、彼女を具現化した玉と彼女の口から出た「燭」を組み合わせたものだ。少し言いずらいせいか、本人は「ユーちゃん」という呼び方のほうが好きだ。 \n鈺燭がキャプテンによく懐き離れたがらないことを鑑み、一番街の警察である赤羽アテナはしばらく彼女をキャプテンの監督下に置くことを提案し、警察がサポートすることを約束した。キャプテンが頷くより早く、ユーちゃんは嬉しそうな顔をした。 \n赤羽アテナが鈺燭の身元と身分を調べている間、キャプテンは保護者としての役割を担っていたが、彼女の成長と変化は、キャプテンが思っていたよりもはるかに速かったようだ……",
    "p104": "萌木原葵",
    "p105": "嶺上の神使",
    "p106": "CV 長縄まりあ",
    "p107": "嶺上の神使にして、一発の巫女。私立南風小学校に通う萌木原葵は、少し前に一番会の設立以降に登録した中で最年少のプロ雀士になったばかりである。\n萌木原葵がこれまでに参加したプロの大会は多くなく、目立った打ち方のスタイルも見せていない。ただ、彼女は一発ツモと嶺上開花であがる頻度が不思議なほど高い。\nまるで牌山を見通しているかのようだ。\n学校や麻雀のプロの大会に参加する時を除き、葵はほとんどの時間を、嶺上区にある稲荷神社の巫女として過ごしている。週末や祝日に神社へ参拝に来た人々は、階段に座ってぼんやりしている小さな姿を見かけることがあるが、一瞬でも注意をそらすと、その姿はすうっと消えてしまう。まるで伝承の中のお稲荷様の使いのように不思議で幻惑的に。",
    "p108": "風間雫",
    "p109": "フリーストリート",
    "p110": "CV 長縄まりあ",
    "p111": "利益を重視するアグレッシブ派。危険を楽しむことが日常となっている。冷静で落ち着いた顔の下で、どれほど狂気的なアイデアが渦巻いているのか、人々は永遠にわからない。\n例えば、ただ非殺傷弾を相手のボスの額に当てるため、スケートボードに乗って屋上から別の屋上に飛び移る。より多く山に残っている牌を捨て、待ち牌が全部王牌に沈む可能性を考慮せず、リーチ地獄待ち。投資する際に見込みの低い株や企業を選び、底打ち後の最大のリターンを得る……彼女は常に自分を危険に晒し、そして華麗な勝利を魅せつける。\n冷静そうな外見と狂気に満ちた行動との対比が印象に残ると言われる。もしかしたら、彼女が危険な行動をとる前に、すでに全部計算済みかもしれない。\nあるいは……ただ正気を失っているだけ。",
    "p112": "エルシー",
    "p113": "贖罪のシスター",
    "p114": "CV 雨宮天",
    "p115": "心の目で魂を見る異国の目隠しシスター、エルシー。フルネームはエルスペス・キャヴェンディッシュ。 \nオルビオンのリンデンデール郡出身のエルシーは、医科大学を卒業した後、国連の人道支援チームにボランティアとして所属し、東大陸の藍藻戦場に赴き、現地で難民への支援活動を行っていた。 \n半年後、戦争が終息した。彼女は故郷に戻らず、医療の道に進まず、代わりに天和市にやって来て、北風町のセントロード大聖堂で洗礼を受け、シスターになった。 \nその時から彼女は自分の目を隠し、世界を見ることを拒否した。 \nしかし、それが彼女がプロ雀士になることに影響を与えない。雀卓上では、牌読み上げ装置なしでも局面を把握し、急所を突く一手を打つことができる。暗闇に迷わされることなく、むしろより明確に見えるようになった。",
    "p116": "如月璃紗",
    "p117": "鬼斬りの少女",
    "p118": "CV 雨宮天",
    "p119": "極東から天和市に転校して来た謎の少女で、注目を集める清楚系モデル。 \n秀桜学園の校門に入ったその瞬間から、如月璃紗は学園の匿名サイトの人気者になった。それからまもなく、ある女性教師の熱心な勧誘を受け、璃紗は美術部に入り、正式に美術モデルになった。それにより、元は静かだった美術部は瞬く間に人気の部活になった。また、『スターファッション』の最新号が発売されると、ある者は表紙にオシャレな服を着た璃紗の写真を見つけた。スタークラブもすぐに正式に如月璃紗の加入を公表した。 \n他人から見ると、高校生としての如月璃紗の人生は、まるでロケットに乗っているようにすごいスピードで飛躍している。しかし、彼女に関する様々な事柄はいまだ謎に包まれている。彼女はいつも夕暮れ時になると消え、どこに住んでいるのかもわからず、友達もいないようで、彼女に近寄った人は寒気すら感じるという……",
    "p120": "冷泉えめこ",
    "p121": "超絶かわいいメカバニー",
    "p122": "CV 咲々木瞳",
    "p123": "天才プログラマーの少女、無表情の「機械ウサギ」。 \n雀士になる前、冷泉えめこは先進技術開発企業である天宮グループで最も若い天才プログラマーとして世界中で有名。同年代の人々がまだ学校の数学問題で苦労している時に、彼女はすでに世界最先端の技術プロジェクトで主力開発チームの一員となっていた。 \n数年後、天和市に派遣され、DAWNグループの傘下にある永遠生命製薬会社とのプロジェクトに協力した。プロジェクトの機密性が高いため、外部からは具体的な研究内容は明らかではないが、両組織の協力は依然として多くの興味と注目を引き付けた。 \n余暇中、冷泉えめこは雀士として活動を始め、徐々に天才というベールを脱ぎ、一般人の前に姿を現した。しかし、彼女が後に示した個性は、人々を驚かせていた…。",
    "p124": "森流歌",
    "p125": "悪魔の手眼",
    "p126": "CV 八巻アンナ",
    "p127": "高地共和国の軍事部隊「薔薇の剣」に所属する軍人。休暇の名目で天和市で活動し、その超科学的な機械の右腕が人に忘れがたい印象を与える。 \nチームDawn運命騎士への加入後、森流歌はリーグ戦にて驚異的な実力を見せつけた。冷酷で容赦のない追撃を得意とする打風で、雀士と観客達から「悪魔の腕」と呼ばれるようになった。 \n対局中、彼女はつぶさに対戦相手を観察し、精神的に大きなプレッシャーを与える。殺到する苦情と度重なる警告の末、森流歌は謝罪とともに、ある程度行動を自粛するようになった。それでも彼女は、当然のように「最も相手にしたくない雀士ランキング」上位に食い込んでいる。"
  },
  "news": {
    "p2": "すべて",
    "p3": "お知らせ",
    "p4": "メンテナンス",
    "p5": "アップデート",
    "p6": "イベント",
    "p7": "イベント「SUMMER LIVE」開催！",
    "p8": "この度、麻雀一番街において、6月30日により期間限定イベント「SUMMER LIVE」の開催及び、新雀士「赤羽アテナ(CV:石川 由依)」&「五月女百合香(CV:石川 由依)」の実装が決定いたしました。",
    "p9": "さらに「一色清美 (CV:小倉 唯)、三宅環奈(CV:新井 里美)や新雀士２名の水着衣装も登場いたします！\n是非イベントへご参加の上、クエストを達成して豪華報酬を獲得しましょう！",
    "p10": "【開催概要】 \n■開催期間\n6/30(木)〜 7/29(金)23:59",
    "p11": "■更新内容\n1. 新雀士「赤羽アテナ」&「五月女百合香」の入手確率UP！\nガチャには、新雀士「赤羽アテナ(CV:石川 由依)」&「五月女百合香(CV:石川 由依)」や限定装飾品の入手確率がアップいたします。\n2.一番街雀士(キャラ4名)の人気総選挙を実施いたします。\n期間内、LIVEクエストをクリアにより応援プレゼントを入手できます。お好きな配信者（キャラ）にプレゼントをすると更に豊富な報酬を獲得できます！\n3. 初回チャージ2倍ボーナスをリセットいたします。\n各価格帯の初回チャージ2倍ボーナスがリセットされます！\n4.コンビニでパックセット販売の追加をいたします！\n\n■新雀士登場",
    "p12": "■水着衣装",
    "p13": "※イベント期間中、クエストをクリアすると特別なアイテムがゲットできますので、ぜひお楽しみください！",
    "p14": "■「麻雀一番街」ダウンロードはこちらから",
    "p15": "・iOS版: {link}",
    "p16": "・Android版: {link}",
    "p17": "・PC版: {link}",
    "p18": "◆ゲームに関する最新情報は公式Twitter、公式サイトで更新しております。",
    "p19": "◆お問い合わせはこちら",
    "p20": "イベント「燃える闘技場」開催！",
    "p21": "9月26日にはイベント「燃える闘技場」と新キャラ2名が麻雀一番街に登場します。                                         \n是非イベントにご参加の上、クエストを達成して豪華報酬を獲得しましょう！",
    "p22": "■「燃える闘技場～地下最強ボクサー～」イベント \nイベント期間：9月26日更新後～10月15日23:59 \n限定称号、アイコンフレーム、雀卓背景と麻雀牌を獲得しよう！",
    "p23": "■新キャラ追加：夏海真凜、五月女直哉 \nガチャ確率UP期間：9月26日更新後～10月18日23:59",
    "p24": "■「キャプテン、全員集合！」イベント \n今までで一番盛り上がるステージが、あなたを待っています！ \nイベント時間：9月26日",
    "p25": "■限定衣装復刻！ \nSteam版リリースの追加記念として、ゲーム内コンビニにて過去に実装された雀士衣装が期間限定で復刻販売決定！ \nぜひこの機会をお見逃しなく！ \n◆東方凪・バニーガール \n◆天海汐月・お菓子ガール \n販売期間：9/26(月)更新後～10/15(土)23:59",
    "p26": "・Steam: {link}",
    "p27": "App Storeの価格改定に伴う一部商品価格改定のお知らせ",
    "p28": "親愛なるキャプテン様：",
    "p29": "いつも「麻雀一番街」をご利用いただきありがとうございます。",
    "p30": "この度、App Storeの価格改定に伴い、麻雀一番街は全プラットフォーム（iOS版、Android版、PC版、Steam版、Apk版）にてゲーム内商品の販売価格が、以下のように改定いたします。",
    "p31": "▼改定内容",
    "p32": "▼改定予定日",
    "p33": "2022年10月5日（水）",
    "p34": "【注意事項】",
    "p35": "・価格改定後-2022年10月18日（火）23:59、各価格帯の初回チャージ2倍以外、次回チャージも追加20％ボーナスがもらえます。",
    "p36": "・価格改定の前後で、ゲーム内の価格表記と各ストアにおける価格表記が一時的に異なる事象が発生する場合がありますので、ご購入の際は必ず価格表記の確認をお願いします。",
    "p37": "・ご利用の環境や端末によっては、価格変更の設定が反映されるまでの時間が異なる場合があります。",
    "p38": "・価格変更前に購入いただいたアイテムは、価格変更後もご利用いただけます。",
    "p39": "・PC版とAPK版には60一番券のメニューがありません。",
    "p40": "・iOS版とAndroid版価格変更前の一部商品の価格は異なります。",
    "p41": "キャプテンの皆様のご理解をいただけますよう、お願い申し上げます。",
    "p42": "麻雀一番街委員会",
    "p43": "「配信者クリスマス大作戦」イベント招待状",
    "p44": "クリスマスを迎えるとともに、麻雀一番街2.0もリリース予定となります。\n麻雀一番街2.0リリース記念として、麻雀一番街は全世界配信者が参加可能なクリスマスイベントを開催致します！\n\nまた、イベント期間中、麻雀一番街の公式アンバサダー：瑞原明奈プロ、松本吉弘プロ、Mリーガー：仲林圭プロ、Vtuber：千羽黒乃、鴨神にゅう、白雪レイドなど100名以上配信者と対局のチャンスがあります！\n\n詳しくは画像をご覧ください！"
  },
  "tour": {
    "p2": "大会",
    "p3": "一番街麻雀大会募集！",
    "p4": "アプリで麻雀大会を開催したい！\n友達と特別なルールで真剣勝負したい！",
    "p5": "こうした声にお応えし、この度「麻雀一番街」の大会室機能が改善されました！\n記念として「一番街麻雀大会募集キャンペーン」を開催いたします！",
    "p6": "▼キャンペーン詳細",
    "p7": "①「麻雀一番街」を使用した大会を企画",
    "p8": "②フォームへご入力の上、応募\nフォーム：{link}",
    "p9": "▼応募時間\n6/23(木)～7/22(金)\n\n▼当選報酬\n①麻雀一番街ゲーム内のお知らせ&SNSアカウントで大会を宣伝いたします\n②麻雀一番街からの大会協賛\n\n※当落発表は当選者の方への連絡をもってかえさせていただきます。追って詳細を相談させていただきます。\n※協賛内容は主催者の経験、大会システム、参加人数などによって相談の上決定させていただきます。",
    "p10": "【公式大会】天下一雀闘会のお知らせ",
    "p11": "麻雀一番街公式大会「天下一雀闘会」の開催が決定いたしました！\n\n参加資格は、2023年7月21日（金）00：00時点で四麻段位「七段以上」であることです。\n\n7月24日（月）~7月26日（水）、毎日19時~24時にかけて予選を行い、7月27日（木）19時~22時にベスト16の準決勝を実施し、7月28日（金）19時~22時にベスト4の決勝戦を実施。7月28日（金）決勝戦では、公式配信を予定しています。 \n\n【参加資格】\n2023年7月21日（金）00：00時点でゲーム内の四麻段位「七段～天下一番」のプレイヤー\n\n【参加方法】\n大会開催期間中、大会参加資格者は下記の大会個室IDにより参戦できます。\n・「予選」個室ID：6597939\n・「準決勝」個室ID：3220100\n・「決勝戦」個室ID：8973769\n\n 【開催期間】\n・予選：2023年7月24日（月）～7月26日（水）毎日19時~24時\n・準決勝：2023年7月27日（木）19時~22時\n・決勝戦：2023年7月28日（金）19時~22時\n \n 【大会競技ルール】\n・４人麻雀\n・半荘戦\n・長考時間：5+20秒\n・25000点持ち・30000点返し（オカなし）\n・1位に必要な点数：30000（西入りあり、トップ者が3万点を超えた時点で終了）\n・順位点：+30、+10、-10、-30\n・赤3枚、一発、裏ドラ、槓ドラあり\n・喰いタン、後付けあり\n・途中流局あり（九種九牌、四風連打、四槓流れ、三家和、四家立直）\n・聴牌連荘あり\n・トビ終了：あり\n・オーラス親はトップの場合、和了終局、聴牌終局となる\n・同点は起親に近い方を優先\n・場所決めと親決めはゲーム側にて決定されます\n\n【予選システム】\n・ランダム対戦で、開催期間中連続5戦の合計スコア上位16名が準決勝に出場(時間内に何回でも対局可能。その中の連続5戦の合計最高スコアを採用)\n・時間：2023年7月24日（月）～7月26日（水）毎日19時~24時\n\n【準決勝システム】\n・同一プレイヤーで半荘戦連続4回を行い、各卓の4戦トータルスコア上位1名が決勝戦に進出\n・ベスト１６→ベスト４となり、勝ち上がり4名での決勝戦を行います\n・時間：2023年7月27日（木）19時~22時\n\n【決勝戦システム】\n・ベスト４が大会個室で半荘戦4回を対戦、4戦のトータルスコアによって優勝者を決めます\n・時間：2023年7月28日（金）19時~22時\n・公式配信実施予定\n\n【不正行為に関して】\n・不正に勝敗を操作する行為、八百長行為を行った場合、その対局は無効となり本大会失格及び永久に麻雀一番街の公式大会参加禁止処分とします。ただし終了した対局結果は無効とはなりません。\n・不正の裁定は、麻雀一番街運営チームや株式会社ACEの審判により行います。大会に関する不正行為が報告または検出された場合、厳正なるチェックを行った上で、公式から対策を施行します。\n\n【遅刻・欠席行為に関して】\n・ベスト１６以降、予選通過者が「参戦できない」旨を【7月27日（木）00:00まで】{link}にお伝えいただいた場合、資格は予選のポイントランキングによって繰り上げとします。\n・ベスト１６以降、事前連絡がなく、開始時間から【5分】経っても対戦に入ってない、連絡も取れない場合は失格となり、ゲームの運営担当が代走で入ります。担当者は勝ち上がりを目指して普通に打ちます、何卒ご了承ください。\n\n【賞品】\n・優勝：優勝トロフィー x1、月間マスコット（180日）、雀券 x50、Amazonギフト券5万円、限定称号「雀闘天下」一年間の使用権利\n・準優勝：月間マスコット（30日）、雀券 x30、Amazonギフト券3万円\n・3位：月間マスコット（30日）、雀券 x20、Amazonギフト券2万円\n・4位：月間マスコット（30日）、雀券 x10、Amazonギフト券1万円\n・5～16位：月間マスコット（30日）、雀券 x5\n・役満賞：対局中に出した役満1回につき、雀券1枚をプレゼント"
  },
  "special": {
    "p2": "スペシャル",
    "p3": "【スタンプ】「天宮健一」スタンプ配布",
    "p4": "天宮健一（CV：森嶋秀太）",
    "p5": "【スタンプ】「雀丸」スタンプ配布",
    "p6": "雀丸（CV：森嶋秀太）",
    "p7": "【スタンプ】「五十嵐紗子」スタンプ配布",
    "p8": "五十嵐紗子（CV：長谷川玲奈）",
    "p9": "【スタンプ】「天海汐月」スタンプ配布",
    "p10": "天海汐月（CV：長谷川玲奈）",
    "p11": "【スタンプ】「九鬼蓮心」スタンプ配布",
    "p12": "九鬼蓮心（CV：新井里美）",
    "p13": "【スタンプ】「一色清美」スタンプ配布",
    "p14": "一色清美（CV：小倉唯)",
    "p15": "【スタンプ】「三宅環奈」スタンプ配布",
    "p16": "三宅環奈（CV：新井里美 )",
    "p17": "【スタンプ】「東方凪」スタンプ配布",
    "p18": "東方凪（CV：小倉唯）",
    "p19": "親愛なるキャプテン様：",
    "p20": "「麻雀一番街」キャンペーン事務局です！\n\n今回は新雀士の登場を記念して、キャラスタンプを配布いたします！",
    "p21": "登場キャラ：",
    "p22": "どんどん使ってくださいね~！",
    "p23": "▼保存方法",
    "p24": "【スマホ】画像を長押し",
    "p25": "【PC】画像をクリック",
    "p26": "【一括ダウンロード】は{here}",
    "p27": "▼スタンプ",
    "p28": "こちら",
    "p29": "【スタンプ】「赤羽アテナ」スタンプ配布",
    "p30": "赤羽アテナ（CV：石川由依）",
    "p31": "【スタンプ】「五月女百合香」スタンプ配布",
    "p32": "五月女百合香（CV：石川由依）",
    "p33": "【アイコン】キャラアイコン配布",
    "p34": "「麻雀一番街」キャンペーン事務局です！\n\n今回は麻雀一番街のリリース半年を記念して、キャラアイコンを配布いたします！\n\nどんどん使ってくださいね~！",
    "p35": "【ヘッダー】Twitterヘッダー配布",
    "p36": "「麻雀一番街」キャンペーン事務局です！\n\n今回は麻雀一番街のリリース半年を記念して、Twitterヘッダーを配布いたします！\n\nどんどん使ってくださいね~！",
    "p37": "▼アイコン",
    "p38": "【スマホ】画像を長押し",
    "p39": "【PC】画像をクリック",
    "p40": "【スマホ】画像を長押し",
    "p41": "【PC】画像をクリック",
    "p42": "▼ヘッダー",
    "p43": "【スタンプ】「夏海真凜」スタンプ配布",
    "p44": "夏海真凜(CV:直田姫奈）)",
    "p45": "【スタンプ】「五月女直哉」スタンプ配布",
    "p46": "五月女直哉(CV:浪川大輔)",
    "p47": "【スタンプ】「深瀬アリス」スタンプ配布",
    "p48": "深瀬アリス(CV:沼倉愛美)",
    "p49": "【スタンプ】「メニヤ」スタンプ配布",
    "p50": "メニヤ(CV:悠木碧)",
    "p51": "【スタンプ】「AU.RO.RA」スタンプ配布",
    "p52": "AU.RO.RA(CV:大西沙織)",
    "p53": "【スタンプ】「白羽飛鳥」スタンプ配布",
    "p54": "【スタンプ】「不二一気」スタンプ配布",
    "p55": "白羽飛鳥（CV：内田真礼）",
    "p56": "不二一気（CV：杉山紀彰）",
    "p57": "【スタンプ】「原道雪」スタンプ配布",
    "p58": "原道雪（CV：ゆかな）",
    "p59": "【スタンプ】「音無郁子」スタンプ配布",
    "p60": "音無郁子（CV：ゆかな）",
    "p61": "【スタンプ】「榎宮澪」スタンプ配布",
    "p62": "榎宮澪（CV：悠木碧）",
    "p63": "【スタンプ】「小倉奏」スタンプ配布",
    "p64": "小倉奏（CV：直田姬奈）",
    "p65": "【スタンプ】「不破真昼」スタンプ配布",
    "p66": "不破真昼（CV：夏吉ゆうこ）",
    "p67": "【スタンプ】「犬飼陽菜」スタンプ配布",
    "p68": "犬飼陽菜（CV：夏吉ゆうこ）",
    "p69": "【スタンプ】「立花薫」スタンプ配布",
    "p70": "立花薫（CV：上村祐翔）",
    "p71": "【スタンプ】「鈺燭」スタンプ配布",
    "p72": "鈺燭（CV：田村ゆかり）",
    "p73": "【スタンプ】一番街 x メモオフ コラボ",
    "p74": "「麻雀一番街」キャンペーン事務局です！\n\n麻雀一番街 × メモリーズオフシリーズ コラボの \nスタンプを3/31(日)までに期間限定配布します！ \n保存、使用はご自由にどうぞ！",
    "p75": "【アイコン】一番街 x メモオフ コラボ",
    "p76": "「麻雀一番街」キャンペーン事務局です！\n\n麻雀一番街 × メモリーズオフシリーズ コラボの\nアイコンを3/31(日)までに期間限定配布します！\n保存、使用はご自由にどうぞ！",
    "p77": "【スタンプ】「萌木原葵」スタンプ配布",
    "p78": "萌木原葵（CV：長縄まりあ）",
    "p79": "【スタンプ】「風間雫」スタンプ配布",
    "p80": "風間雫（CV：長縄まりあ）",
    "p81": "【スタンプ】「エルシー」スタンプ配布",
    "p82": "エルシー（CV：雨宮天）",
    "p83": "【スタンプ】「麻雀一番街 × ダンガンロンパ」コラボ",
    "p84": "「麻雀一番街」キャンペーン事務局です！\n\n麻雀一番街 × ダンガンロンパ コラボの\nスタンプを7/30 23:59までに期間限定配布します！\n保存、使用はご自由にどうぞ！",
    "p85": "【スタンプ】「如月璃紗」スタンプ配布",
    "p86": "如月璃紗（CV：雨宮天）",
    "p87": "【スタンプ】「森流歌」スタンプ配布",
    "p88": "森流歌（CV：八巻アンナ）",
    "p100": "「麻雀一番街」キャンペーン事務局です！\n\n今回は新雀士の登場を記念して、キャラスタンプを配布いたします！"
  },
  "verify": {
    "p2": "牌山生成方法の公開",
    "p3": "牌山の生成方法を公開します。",
    "p4": "1.ゲーム内の牌山は完全なランダムで生成します。作為的に配牌を選択、特定の局面で山を操作することは一切ありません。牌山の生成コードを以下に公開いたします。",
    "p5": "2.「完全ランダム」を証明するため、SHA-256コードをゲーム内に導入いたします。",
    "p6": "①各局の牌山は対応のSHA-256コードがあります。プレーヤーは各局左上の説明から当局のSHA-256コードを確認可能です。\n②対局終了後、プレーヤーは牌譜内で当局の「牌山コード」を確認できます。SHA-256検証サイトで「牌山コード」を入力すると、SHA-256コードを獲得可能です。対局中のSHA-256コードと比較すると、完全一致の結果を獲得できます。それにより、牌操作が一切ないことを証明できます。",
    "p7": "3.牌山コードルール：",
    "p8": "①萬子：mで表示する（1~9m=1~9萬、0m=赤5萬）\n②筒子：pで表示する（1~9p=1~9筒、0p=赤5筒）\n③索子：sで表示する（1~9s=1~9索、0s=赤5索）\n④字牌：zで表示する（1~7z=東、南、西、北、白、發、中）\n牌山コードの順番は牌山の順番と同じです。",
    "p9": "Q＆A",
    "p10": "Q1：コードを公開する理由は？",
    "p11": "A：\n①「麻雀一番街」はオンライン対戦麻雀として、プレーヤーに公平な環境を確保し、十分に実力を発揮できることを目指しています。牌山の生成方式は公平性に影響する重要な要素の一つです。麻雀一番街は常にランダムな牌山の生成を採用していますが、この度はそのことをプレーヤーの皆様に知っていただくため、公開いたしました。\n②コード公開することで、全局の牌山はランダムで生成され、操作が一切ないことを証明できます。また、SHA-256コードは、牌山は「最初から最後まで」変更されていないことを証明できます。\n③「麻雀一番街」は今後「即時牌山レコード」（全ての配牌の各種類比率を即時サイトに反映する）の公開を予定しております。\n④ご意見やご要望がありましたらriichicitysupport@mahjong-jp.comまでお気軽にご連絡ください。",
    "p12": "Q2：MD5ではなくSHA-256コードを選択した理由は？",
    "p13": "MD5は唯一、不可逆の特性があり、暗号や認証、デジタル署名などの手段として様々な場面で利用されていています。\nしかし、SHA-256コードはより安全なセキュリティコードでございます。確率はかなり低いですが、MD5コードは衝突により攻撃される可能性がありますので、それを避けるため、SHA-256コードを使用いたしました。\nこれにより、「麻雀一番街」は全力でユーザーの安全性を保証いたします。",
    "p14": "Q3：牌山全体のコードを公開する理由は？",
    "p15": "A：手牌の配布も操作もないことを証明するために、手牌含めて牌山を公開いたします。"
  },
  "streamer": {
    "p2": "配信者専用",
    "p3": "麻雀一番街へようこそ！",
    "p4": "▼配信素材ダウンロード",
    "p5": "「麻雀一番街」は配信者の皆様のために素材を用意いたしました。",
    "p6": "実況配信や二次創作で利用可能です。",
    "p7": "ダウンロードはこちら",
    "p8": "▼お問い合わせ",
    "p9": "以下の希望がありましたら、いつでもご連絡ください。",
    "p10": "麻雀一番街で大会を開催したい（協賛を相談したい）",
    "p11": "麻雀一番街の公式認証配信者になりたい",
    "p12": "他に麻雀一番街へのご意見、ご要望、相談したいことがある場合",
    "p13": "連絡先メール: ",
    "p14": "今後とも「麻雀一番街」をよろしくお願いいたします。",
    "p15": "riichicitysupport@mahjong-jp.com",
    "p16": "通常配信素材：ダウンロードはこちら",
    "p17": "星辰LIVE素材：ダウンロードはこちら",
    "p18": "強欲の船素材：ダウンロードはこちら",
    "p19": "スピードレーサー素材：ダウンロードはこちら",
    "p20": "緋色の真夏素材：ダウンロードはこちら"
  },
  "riichicitystore": {
    "p2": "読み込み中…"
  },
  "survey_bg": {
    "p2": "\n  ",
    "p3": "「超高校級」",
    "p4": "の才能を",
    "p5": "発掘するため、",
    "p6": "我々——希望ヶ峰学園は、\n「超高校級診断」を開発した。\n是非、参加をお願いしたい。",
    "p7": "キミは、どんな才能を持っているだろうか？",
    "p8": "テスト開始",
    "p9": "やり直す",
    "p10": "結果をシェアする",
    "p11": "超高校級診断",
    "p12": "超高校級の",
    "p13": "次へ",
    "p14": "言語選択",
    "p15": "診断する",
    "p16": "もう一度",
    "p17": "保存",
    "p18": "シェア",
    "p19": "麻雀一番街公式サイト",
    "p20": "保存完了",
    "p21": "シェア完了",
    "p22": "その他",
    "p23": "戻る",
    "p24": "WeChat",
    "p25": "Weibo",
    "p26": "Baidu Tieba",
    "p27": "診断へ",
    "p28": "『麻雀一番街』×『ダンガンロンパ』コラボイベント",
    "p30": "コラボイベント「超高校級診断」のシェア報酬",
    "p31": "親愛なるキャプテン、「超高校級診断」にご参加いただき、ありがとうございます！以下の報酬を受け取ってください！",
    "p32": "ゲーム内メールにて報酬が送られていますので、メールをご確認ください。",
    "p36": "『麻雀一番街』×『ダンガンロンパ』コラボイベントの診断結果は",
    "p37": "でした！リンクをタップして診断に参加しましょう！",
    "p41": "『麻雀一番街』コラボイベント",
    "p42": "『麻雀一番街』診断結果は",
    "p43": "リンクをタップして診断に参加しましょう！",
    "p46": "超高校級診断",
    "p47": "一番街ダンガンロンパコラボ",
    "p48": "『麻雀一番街×ダンガンロンパコラボ』<超高校級診断>",
    "p51": "イベントが終了しました",
    "p52": " ",
    "p53": "秒後",
    "p54": "「麻雀一番街」",
    "p55": "公式サイトに飛びます"
  },
  "survey_question": {
    "p2": "努力と運、どちらが大切だと思いますか？",
    "p3": "努力",
    "p4": "運",
    "p5": "キミはアウトドア派ですか？インドア派ですか？",
    "p6": "アウトドア派",
    "p7": "インドア派",
    "p8": "ひとりで過ごすのとみんなで過ごすのどちらが好きですか？",
    "p9": "ひとりで",
    "p10": "みんなで",
    "p11": "推理と想像、どちらが好きですか？",
    "p12": "推理",
    "p13": "想像",
    "p14": "キミは山派ですか？海派ですか？",
    "p15": "山派",
    "p16": "海派",
    "p17": "スピードとパワー、どちらに自信がありますか？",
    "p18": "スピード",
    "p19": "パワー",
    "p20": "キミは話す派ですか？聞く派ですか？",
    "p21": "話す派",
    "p22": "聞く派",
    "p23": "わからない",
    "p24": "2次元と3次元、どちらが好きですか？",
    "p25": "2次元",
    "p26": "3次元",
    "p27": "キミは運がいいですか？",
    "p28": "強運",
    "p29": "普通",
    "p30": "キミは理性派ですか？それとも感性派ですか？",
    "p31": "理性派",
    "p32": "感性派",
    "p33": "既知と未知、どちらが好きですか？",
    "p34": "既知",
    "p35": "未知",
    "p36": "麻雀と本、どっちが好きですか？",
    "p37": "麻雀",
    "p38": "本",
    "p39": "静かなところと賑やかなところ、どちらが好きですか？",
    "p40": "静か",
    "p41": "賑やか",
    "p42": "キミは冷静派ですか？熱血派ですか？",
    "p43": "冷静派",
    "p44": "熱血派",
    "p45": "キミはポジティブ派ですか？ネガティブ派ですか？",
    "p46": "ポジティブ派",
    "p47": "ネガティブ派",
    "p48": "そうよ...こんな結末、やっぱり何か間違っている。\nこのまま終わっちゃったら、絶望的だと思うんだけど？",
    "p49": "絶望的",
    "p50": "超絶望的"
  },
  "survey_result": {
    "p2": "超高校級の格闘家",
    "p3": "キミは山のように穏やかな人だが、\n類まれな武芸の才がある。\n大自然の中、厳しい修行を重ね、\n一撃必殺の奥義を習得すれば、\n天人合一を果たすだろう。",
    "p4": "超高校級のスイマー",
    "p5": "キミは水のように優しく、太陽のように温かい人。\nいつも一人で訓練してきたが、\n明るい性格で集団活動でもうまくやっていける。\n信じていい、キミが流した汗と涙はきっと報われる。",
    "p6": "超高校級の暴走族",
    "p7": "キミは明確な目標があって、\n決してめげることのない男の中の男。\n加速するのだ！疾風と稲妻がキミの翼となる！\nただし、交通安全には注意するように。",
    "p8": "超高校級の野球選手",
    "p9": "キミは陽気で情熱的な性格であり、誰とでも仲良くなれる。\nずば抜けた腕力と動体視力の持ち主で、\n投げるボールはミサイル級。\nトレーニングを続ければ、いつか世界的有名な\nプロ選手になれるかもしれないぞ。",
    "p10": "超高校級の風紀委員",
    "p11": "キミは公正無私で集団を重んじる人。\n秩序は破壊することよりも、\n維持することの方がはるかに困難であることを、\nキミはよく理解しているから。\nその仏頂面の下に隠されている優しい心を、大切にしてくれ。",
    "p12": "超高校級のプログラマー",
    "p13": "キミは口数は少ないが、頭の回転が速く、論理的な人。\nキミが綴ったコードは思考の分身であり、\n人々にその輝く才能を表現している。\n好きなことをやればいい。他人に好かれることよりも、\n自分が好きな自分でいることの方が大事だから。",
    "p14": "超高校級の？？？",
    "p15": "キミは謎多き人物……。\nどんな才能を秘めているのか、診断だけでは解読不能だ。\nそれこそが、キミの才能なのかもしれない。",
    "p16": "超高校級の同人作家",
    "p17": "素晴らしい想像力と二次元への愛があるね！\n是非とも筆をとり、その想像と愛を、他者に伝えてほしい。\nそれは素晴らしく偉大な才能だ。",
    "p18": "超高校級の文学少女",
    "p19": "キミはなんて才気あふれる少女なんだ！！\n将来は恋愛小説のベストセラー作家で間違いない！！\n…なに？少女じゃないだと？\nそれは大変失礼した。つい興奮してしまってな…。",
    "p20": "超高校級のギャンブラー",
    "p21": "キミが見せる表情の裏で、\n本当は何を考えているのか？誰も知ることはできない。\nキミと賭けをすることは不運だ、\nなぜなら最初から結果は決まっていたから。\nギャンブルに必勝法は存在しないが、必勝のキミはいる。",
    "p22": "超高校級の御曹司",
    "p23": "キミは冷酷なまでに理性的な人。\n生まれつき圧倒的な優位性を持っていても、\nそれを誇らしげにすることはない。\nかぶった王冠の重さに、どうか押しつぶされないで欲しい。\n王道と呼ばれる茨の道を、\n振り返ることなく進んでいってくれ。",
    "p24": "超高校級の占い師",
    "p25": "キミはロマンチストで、世俗的な成功に無関心な人。\nその頭の中にはもう一つ美しい星空が広がっている。\nたとえ結果を疑われたとしても、\n友達の運命を占ってあげてくれ。",
    "p26": "超高校級のアイドル",
    "p27": "キミは人々に笑顔をもたらすことができる人だ。\nもしプロのアイドルになれたら、きっと大物になれる。\nその活気に満ちたパフォーマンスは\n多くの人を虜にするだろう。",
    "p28": "超高校級の軍人",
    "p29": "戦場で生き残るには運が必要だが、\n運以上に重要なのは冷静さだ。\nキミは優れた洞察力と冷静な頭脳を持っている。\n危機を迅速に見極め、解決することができるだろう。\n…ただし、最も安全だと思われる場所が、\n実は最も危険かもしれない。用心してくれ。",
    "p30": "超高校級の幸運",
    "p31": "特に目立った特徴はないようだ。\nほとんどの普通の人と同じように、普通の生活を送っている。\n悲しんだり、喜んだり、恐れたり、時には勇敢になったり…。\n普通に毎日を過ごすことこそが、\n最大の幸運なのかもしれない。",
    "p32": "超高校級のギャル",
    "p33": "キミはファッションの達人だね！\n街を歩くとたくさんの注目を浴びるくらい、\n魅力が溢れている！\n思わぬところで有名なファッションショーに\n招待されるかもしれないね。",
    "p34": "超高校級の絶望",
    "p35": "はあ？ファッションショー？冗談はやめてくれ…。\nキミが世界にもたらすのはそんな普通なものじゃない。\nその才能はすべての人々を絶望に陥れ、\n絶望に包み込まれ、最後には絶望に飲み込まれるんだ。\n絶望を存分に味わってくれ。"
  },
  "survey_profession": {
    "p2": "格闘家",
    "p3": "スイマー",
    "p4": "暴走族",
    "p5": "野球選手",
    "p6": "風紀委員",
    "p7": "プログラマー",
    "p8": "超高校級の",
    "p9": "同人作家",
    "p10": "文学少女",
    "p11": "ギャンブラー",
    "p12": "御曹司",
    "p13": "占い師",
    "p14": "アイドル",
    "p15": "軍人",
    "p16": "幸運",
    "p17": "ギャル",
    "p18": "絶望"
  },
  "sgtest_quest": {
    "p2": "極めて強い重力をもつ、超高密度の天体は何ですか？",
    "p3": "ブラックホール",
    "p4": "彗星",
    "p5": "チョコレート",
    "p6": "マヤ人が世界の終わりを予言したのは何年ですか？",
    "p7": "2012年",
    "p8": "2024年",
    "p9": "2000年",
    "p10": "岡部倫太郎がよく飲んでいる知的飲料「ドクペ」とは何ですか？",
    "p11": "致死量のわさびを入れた味噌汁",
    "p12": "独特な味がする炭酸飲料",
    "p13": "飲むと眠くなる紅茶",
    "p14": "次のうち、お腹の中の赤ちゃんの性別を変える行為はどれですか？",
    "p15": "バナナを食べる",
    "p16": "麻雀をする",
    "p17": "お腹の中の赤ちゃんの性別は変えられない",
    "p18": "ギリシャ文字の中で、始まりを表す文字はどれですか？",
    "p19": "Ω",
    "p20": "α",
    "p21": "β",
    "p22": "血糊を発光させる画期的なアイデアと、柄を取り付けたことにより、リアルなチャンバラごっこを可能にした未来ガジェットの名前は？",
    "p23": "モアッド・スネーク",
    "p24": "サイリウム・セーバー",
    "p25": "ビット粒子砲",
    "p26": "わずかな変化を与えたことにより、非常に小さな出来事が、最終的に予想もしていなかったような大きな出来事につながることを意味する言葉は、どれですか？",
    "p27": "バタフライ効果",
    "p28": "ミツバチ効果",
    "p29": "ユニコーン効果",
    "p30": "脳の中には記憶に重要な役割を果たす部位があります。\n海洋生物に似ていることからその名前が付けられました。その海洋生物とは何ですか？",
    "p31": "ハリセンボン",
    "p32": "マンボウ",
    "p33": "タツノオトシゴ",
    "p34": "相対性理論を発見したのは誰ですか？",
    "p35": "織田信長",
    "p36": "鳳凰院凶真",
    "p37": "アインシュタイン",
    "p38": "北欧神話において、戦争を司る女神の名前は何ですか？",
    "p39": "ヴァルキリー",
    "p40": "イザナミ",
    "p41": "ゼウス",
    "p42": "Dメールで送れるデータ量は36バイトですが、全角文字で何文字に相当しますか？",
    "p43": "36",
    "p44": "12",
    "p45": "18",
    "p46": "地球から銀河系中心までの距離はどれくらいですか？",
    "p47": "384399km",
    "p48": "2.6万光年",
    "p49": "16.4光年",
    "p50": "夏の大三角の中で、直角の頂点にあり、七夕の伝説に深く結びついている星はどれですか？",
    "p51": "ベガ",
    "p52": "アルタイル",
    "p53": "デネブ",
    "p54": "宇宙で最も多く存在する元素は何ですか？",
    "p55": "水素",
    "p56": "硫黄",
    "p57": "酸素",
    "p58": "桐生萌郁は重度の携帯依存症で、常に携帯画面を見つめ、キーを打つ速さは天下一品です。\n次のうち、彼女のニックネームとして正しいのはどれですか？",
    "p59": "閃光の指圧師",
    "p60": "電光石火の脳",
    "p61": "輝きの魔眼",
    "p62": "阿万音鈴羽の自転車の速度は20km/hで、岡部倫太郎のは12km/hです。\n彼らがAB地点から同時に出発し、16Kmの距離を向かい合って進むと、どれくらいの時間で出会うことができますか？",
    "p63": "1h",
    "p64": "30min",
    "p65": "40min",
    "p66": "人気アニメ「雷ネット翔」に登場するマスコットキャラクターの名前は何ですか？",
    "p67": "うーぱ",
    "p68": "おかりん",
    "p69": "ゲロカエルん",
    "p70": "次のうち、岡部倫太郎が別れの挨拶として使っている言葉はどれですか？",
    "p71": "エル・プサイ・コングルゥ",
    "p72": "エル・プサイ・コンガリー",
    "p73": "エル・プサイ・コンクルゥ",
    "p74": "ラボメンバッジの縁にはメンバーの名前の頭文字が刻まれています。\n次のうち、正しい順番はどれですか？",
    "p75": "OSHMKFUA",
    "p76": "OSHMKUFA",
    "p77": "OSHKMUFA",
    "p78": "1975年に発売され、岡部倫太郎が秋葉原中を探して回った幻のレトロPCの名前は何ですか？",
    "p79": "IBN5100",
    "p80": "IBN5110",
    "p81": "IBM5100",
    "p82": "2036年の世界からやってきた、タイムトラベラーとは誰ですか？",
    "p83": "ジョン・タイター",
    "p84": "ルドルフ・フェンツ",
    "p85": "ドーラ・アイモン",
    "p86": "麻雀一番街の三麻段位戦のルールにおいて、途中流局になるのはどの状況ですか？",
    "p87": "九種九牌",
    "p88": "四風連打",
    "p89": "三家立直",
    "p90": "麻雀一番街の段位戦のルールにおいて、緑一色を和了するためにどの牌が不要ですか？",
    "p91": "7索",
    "p92": "8索",
    "p93": "発",
    "p94": "麻雀一番街の段位戦のルールにおいて、役満ではないのはどれですか？",
    "p95": "四暗刻",
    "p96": "九蓮宝燈",
    "p97": "清一色"
  },
  "sgtest_bg": {
    "p2": "残念だが、運命はお前を選ばなかったようだ…再挑戦を待っている。",
    "p3": "お前はラボメンとしての資格を得た。だが、これで満足するな。真の試練はこれからだ。",
    "p4": "闇の力に導かれし者よ、ここに集いし運命を受け入れよ！",
    "p5": "これより先、お前は運命の共犯者だ！覚悟はいいか？",
    "p6": "ようこそ、未来ガジェット研究所へ！世界の真理を暴き、共に闇の中を進もう！",
    "p7": "勉強してもう一回チャレンジしてほしいな。まゆしぃも応援するから。ね？",
    "p8": "やったねー！でもでも、もっと点数が上がったところも見てみたいな。",
    "p9": "すごーい！ビックリなのです。これからはラボメンとして、一緒に頑張ろうね！",
    "p10": "こんな結果みたの初めてだよー。えっへへー、負けてられないなー。",
    "p11": "まゆしいは今、とっても感動してるのです！おめでとう！",
    "p12": "基礎が甘いわね。次回はもっと準備をして挑戦してみて。",
    "p13": "まあ、合格ね。でも満足しないで、まだ伸びしろがあるから。",
    "p14": "おめでとう。あなたの実力は間違いないなさそうね。",
    "p15": "ふむん。この結果は見事ね。自信を持っていいと思う。",
    "p16": "100点を取るのは5％の確率しかない。あなたは自分を誇るべきよ。",
    "p17": "諦めなければなんとかなるって！次は頑張ろう！",
    "p18": "これで合格だけどさ、まだまだ戦いは続くからね！",
    "p19": "やるねー、この！戦士としての実力を見せつけられちゃったよ。",
    "p20": "こんな高い点数が取れるなんてさ、君のこと尊敬しちゃう！",
    "p21": "すごいじゃん！君はもうあたしと同じ、一人前の戦士だね！",
    "p30": "ダウンロード特典",
    "p31": "ラボメン適性テスト",
    "p32": "我が未来ガジェット研究所では、麻雀一番街に臨時支部を設置し、\n機関との最終聖戦に向け、共に戦ってくれる仲間を募集している。\n能力適合者には、この鳳凰院凶真が、血の盟約を授けよう。",
    "p33": "入所条件：",
    "p34": "適性テストで    <span style=\"color: #3c3a43\">60</span>\n点以上取れる。",
    "p35": "やる",
    "p36": "捨てる",
    "p37": "お、おい！この絶好のチャンスを見逃すつもりか！？\nこの狂気のマッドサイエンティスト、鳳凰院凶真の仲間になれるのだぞ？",
    "p38": "仕方ない",
    "p39": "イベントは終了しました。\n「麻雀一番街」公式サイトに3秒後に自動的に移動します。",
    "p40": "名前",
    "p41": "テストする",
    "p42": "次へ",
    "p43": "終了する",
    "p44": "得点",
    "p45": "惜しい…今度こそ頑張ろう！",
    "p46": "合格おめでとう！ラボメン",
    "p47": "もう一度",
    "p48": "保存する",
    "p49": "シェア",
    "p50": "報酬が配布されましたので、ゲーム内のメールでご確認ください～",
    "p51": "シェアして麻雀牌を獲得",
    "p52": "ニックネームの中に、不適切な文字列が含まれています。",
    "p53": "8文字以内で入力してください（英字は16文字以内）",
    "p54": "ニックネームを入力してください",
    "p55": "8文字以内で入力する",
    "p56": "1つ以上の選択肢を選択してください～",
    "p57": "保存完了",
    "p58": "一番街シュタゲコラボ",
    "p59": "麻雀一番街",
    "p60": "シュタゲ",
    "p61": "「麻雀一番街×シュタインズ・ゲートコラボ」期間限定イベント＜ラボメン適性テスト＞"
  }
}